<span [innerHTML]="textBefore"></span>
&ngsp;
<ap-button (click)="onTextClick()" [text]="true" [ariaLabel]="ariaLabel" #textButton>{{ textClick }}</ap-button>
&ngsp;
<span [innerHTML]="textAfter"></span>
